// extracted by mini-css-extract-plugin
module.exports = {"predmetiPoGodiniContainer":"Smer_predmetiPoGodiniContainer__3n6Pj","smerTitle":"Smer_smerTitle__1S0Wk"};